"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settlementGuideDialogState_1 = require("../settlementGuideDialogState");
const _1 = require(".");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const guideTabVal = (0, recoil_1.useRecoilValue)(settlementGuideDialogState_1.settlementGuideTabState);
    const isLeaderTab = guideTabVal === 'leader';
    const isUsedTransferTab = guideTabVal === 'used/transfer';
    const isRewardTab = guideTabVal === 'reward';
    const leaderSubTabVal = (0, recoil_1.useRecoilValue)(settlementGuideDialogState_1.settlementGuideLeaderSubTabState);
    const isProductCostSubTab = leaderSubTabVal === 'productCost';
    const isAgencyPurchaseSubTab = leaderSubTabVal === 'agencyPurchase';
    const isHandmadeSubTab = leaderSubTabVal === 'handmade';
    const isEventSubTab = leaderSubTabVal === 'event';
    const isShippingFeeSubTab = leaderSubTabVal === 'shippingFee';
    const usedTransferSubTabVal = (0, recoil_1.useRecoilValue)(settlementGuideDialogState_1.settlementGuideUsedTransferSubTabState);
    const isCashSubTab = usedTransferSubTabVal === 'cash';
    const isTransferSubTab = usedTransferSubTabVal === 'transfer';
    const isCombinedTransferSubTab = usedTransferSubTabVal === 'combinedTransfer';
    return ((0, jsx_runtime_1.jsxs)(SettlementGuideContentsDiv, { children: [isLeaderTab && isProductCostSubTab && (0, jsx_runtime_1.jsx)(_1.ProductCostGuide, {}), isLeaderTab && isAgencyPurchaseSubTab && (0, jsx_runtime_1.jsx)(_1.AgencyPurchaseGuide, {}), isLeaderTab && isHandmadeSubTab && (0, jsx_runtime_1.jsx)(_1.HandmadeGuide, {}), isLeaderTab && isEventSubTab && (0, jsx_runtime_1.jsx)(_1.EventGuide, {}), isLeaderTab && isShippingFeeSubTab && (0, jsx_runtime_1.jsx)(_1.ShippingFeeGuide, {}), isUsedTransferTab && isCashSubTab && (0, jsx_runtime_1.jsx)(_1.CashGuide, {}), isUsedTransferTab && isTransferSubTab && (0, jsx_runtime_1.jsx)(_1.TransferGuide, {}), isUsedTransferTab && isCombinedTransferSubTab && (0, jsx_runtime_1.jsx)(_1.CombinedTransferGuide, {}), isRewardTab && (0, jsx_runtime_1.jsx)(_1.RewardGuide, {})] }));
}
exports.default = default_1;
const SettlementGuideContentsDiv = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 20px;

  .required_emphasis {
    margin-bottom: 10px;
    color: var(--primary-dark);
  }

  .bulleted {
    display: flex;
    &::before {
      content: ' • ';
      margin: -2px 6px 0px;
      font-weight: bold;
    }
  }

  .single_img_wrapper {
    display: flex;
    justify-content: center;
  }

  .pair_img_wrapper {
    display: flex;
    align-items: flex-start;
    column-gap: 10px;
    padding: 0 10px;
  }
  .img_50 {
    width: 50%;
  }
  .img_100 {
    width: 100%;
  }
  .after_img_wrapper {
    position: relative;
    display: flex;
    &::after {
      position: absolute;
      inset: 0;
      border-radius: 8px;
      border: 1px solid var(--gray-10);
      content: '';
    }
    > img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
`;
